import {clone} from 'lodash';
import number from './number';

const decimal = clone(number);
decimal.format = function formatDecimal(v) {
  return parseFloat(Math.round(v * 100) / 100).toFixed(2);
};

export default decimal;



// WEBPACK FOOTER //
// ./src/components/vue-good-table/components/types/decimal.js